import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { AssociatedPhrase } from "@shared/models/associated-phrase.model";
import { AssocPhrasesRequest } from "@shared/models/assoc-phrases-request";
import { ClaimToolElement } from "@shared/models/claim-tool-element.model";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { ClaimToolService } from "@shared/services/claim-tool.service";
import { AssociatedTextPhrase } from "@shared/models/common";
import { ClaimToolElementSaveChangesData } from "@shared/models/claim-tool-element-save-changes-data.model";

@Component({
    selector: 'doc-assoc-text-options',
    templateUrl: './doc-assoc-text-options.component.html',
    styleUrls: ['./doc-assoc-text-options.component.scss'],
    standalone: false
})
export class DocAssocTextOptionsComponent implements OnInit, OnDestroy {

    @Input() assocPhrasesRequest: AssocPhrasesRequest;

    @Input() disabled: boolean = false;

    filterValue: string = 'not_associated_by_other';
    
    displayAssocText: AssociatedPhrase[] = [];

  constructor(private claimToolService: ClaimToolService, private ngRedux: NgRedux<AppState>) {}

    loading: boolean;
    assocTextOptions: AssociatedPhrase[] = [];
    
    displayGenAi: boolean = false;

    get claimToolElement(): ClaimToolElement {
      
      return this.ngRedux.getState().claimToolElement;
    }

    get claimToolSaveChangesDataInitialValues(): ClaimToolElementSaveChangesData {

      return this.ngRedux.getState().claimToolSaveChangesDataInitialValues;
    }


    ngOnInit(): void {

        this.loading = true;
        this.assocTextOptions = [];
        this.claimToolService.getAssocPhrases(this.assocPhrasesRequest).subscribe(
          (assocTextOptions) => {
/*             assocTextOptions.forEach(phrase => {
               
              phrase.initially_associated = phrase.is_associated;
            }); */
            this.assocTextOptions = assocTextOptions;
            if (this.assocTextOptions.length > 0) {
              this.displayGenAi = this.assocTextOptions[0].display_genai;
            }
            this.loading = false;
            this.setAssociationsStatus();
            this.displayAssocText = this.assocTextOptions?.filter(assocTextOption => !assocTextOption.associated_by_others) || [];
          },
          () => (this.loading = false) 
        )
    }

  add(phrase: AssociatedPhrase, deAssocOthers: boolean = false) {

    if (this.disabled) {
      return;
    }
    
    phrase.is_associated = true;
    let idx = this.claimToolElement.deletedAssociatedText.findIndex(
      (r) => r.assocPhraseId == phrase.phrase_id
    );
    if (idx != -1) {

      this.claimToolElement.deletedAssociatedText.splice(idx, 1);
    }
    let assocPhrase = new AssociatedTextPhrase();
    assocPhrase.assocPhraseId = phrase.phrase_id;
    assocPhrase.phraseId = this.claimToolElement.phraseId;
    assocPhrase.assocPhraseText = phrase.phrase_text;
    assocPhrase.deAssocOthers = deAssocOthers;
    //assocPhrase.newSw = true;
    this.claimToolElement.associatedText.push(assocPhrase);
    this.claimToolService.manageContentChanged$.next(this.compareWithInitialArray());  
  }

  remove(phrase: AssociatedPhrase) {
    
    if (this.disabled) {
      return;
    }
    phrase.is_associated = false;
    let idx = this.claimToolElement.associatedText.findIndex(
      (r) => r.assocPhraseId == phrase.phrase_id
    );
    if (idx != -1) {
      const removedAssocText = this.claimToolElement.associatedText[idx];
      //removedAssocText.deleteSw = true;
      this.claimToolElement.deletedAssociatedText.push(removedAssocText);
      this.claimToolElement.associatedText.splice(idx, 1);
      this.claimToolService.manageContentChanged$.next(this.compareWithInitialArray());
    } 
 }
  onFilterChange() {
      if (this.filterValue == 'all') {
        this.displayAssocText = this.assocTextOptions;
        return;
      }
        this.displayAssocText = this.assocTextOptions.filter(assocTextOption => !assocTextOption.associated_by_others);
    }
  canRemovePhrase(phrase: AssociatedPhrase): boolean {
      
    return phrase.is_associated;
      
    }
    canAddPhrase(phrase: AssociatedPhrase): boolean {
     
      return !phrase.is_associated && !phrase.associated_by_others;
    }

    canDeAssocPhrase(phrase: AssociatedPhrase): boolean {

      return !phrase.is_associated && phrase.associated_by_others
    }
    ngOnDestroy(): void {
      

    }

    setAssociationsStatus() {

    this.claimToolElement.associatedText = [];    
    let associatedText = [];
    for(let i=0; i<this.assocTextOptions.length; i++) {
      
      let phraseToAdd = this.assocTextOptions[i];
      let assocPhrase = new AssociatedTextPhrase();

      if (phraseToAdd.is_associated) {
        
        assocPhrase.assocPhraseId = phraseToAdd.phrase_id;
        assocPhrase.phraseId = this.claimToolElement.phraseId;
        assocPhrase.assocPhraseText = phraseToAdd.phrase_text;
        associatedText.push(assocPhrase);
      }

    }
      this.claimToolElement.associatedText = associatedText;
      this.claimToolSaveChangesDataInitialValues.associatedText = JSON.parse(JSON.stringify(associatedText));  
  }

    private compareWithInitialArray(): boolean {

      const initialAssociations = this.claimToolSaveChangesDataInitialValues.associatedText;
      const currAssociations = this.claimToolElement.associatedText;

      if (currAssociations.length != initialAssociations.length) {
        // associations deleted 
        // associations added  
        return true;
      }
      // same length
      // reference added and reference deleted
      // we need to check if reference is added that werent in array
      for (let i=0; i<currAssociations.length; i++) {
        
        const currAssociation = currAssociations[i];
        const foundedAssociation = initialAssociations.findIndex(association => currAssociation.assocPhraseId == association.assocPhraseId);
        
        if (foundedAssociation == -1) {
          // added reference
          // not in initial references
          return true;
        }
      }
      return false;
    }

}


